module.exports = __webpack_public_path__ + "static/media/haircut_map_important.0f6113f8.svg";